import { detachKeys } from '~/utils';
import useHandbook from './useHandbook';

type MCCType = {
  id?: string | undefined;
  name?: string | undefined;
};

type UseMCC = {
  codes: MCCType[];
  codesDict: Record<string, MCCType>;
  getMCC: (mcc?: string | number) => string;
};

const useMCC = (): UseMCC => {
  const { data } = useHandbook();
  const codes = data?.merchantCategoryCodes || [];
  const [codesDict] = detachKeys<MCCType>(codes);

  const getMCC: UseMCC['getMCC'] = (mcc = '') => {
    return codesDict[mcc]?.name || mcc.toString();
  };

  return { codes, codesDict, getMCC };
};

export default useMCC;
